import { render, staticRenderFns } from "./IconSvgClip.vue?vue&type=template&id=1d3c8871&scoped=true&"
import script from "./IconSvgClip.vue?vue&type=script&lang=js&"
export * from "./IconSvgClip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c8871",
  null
  
)

export default component.exports